import type { MtbTrailDifficulty, MtbTrailRelatedPlace } from "~/lib/api";
import { MtbDifficultyIcon } from "~/components/ui/icons/difficulty-icons";
import { cn } from "~/lib/utils";

const DIFFICULTY_ORDER: MtbTrailDifficulty[] = ["green", "blue", "black", "double-black", "proline"];

interface TrailDifficultySummaryProps {
  trails: MtbTrailRelatedPlace[];
  compact?: boolean;
  outline?: boolean;
  className?: string;
}

export function TrailDifficultySummary({ trails, compact, outline, className }: TrailDifficultySummaryProps) {
  const counts = new Map<MtbTrailDifficulty, number>();
  for (const trail of trails) {
    const difficulty = trail.metadata?.difficulty;
    if (difficulty) {
      counts.set(difficulty, (counts.get(difficulty) ?? 0) + 1);
    }
  }

  if (counts.size === 0) return null;

  return (
    <div className={cn("flex", compact ? "gap-2" : "gap-3", className)}>
      {DIFFICULTY_ORDER.map((difficulty) => (
        <span
          key={difficulty}
          aria-label={`${counts.get(difficulty) ?? 0} ${difficulty}`}
          className={cn("inline-flex items-center", compact ? "gap-0.5" : "flex-col gap-0.5")}
        >
          <MtbDifficultyIcon
            difficulty={difficulty}
            outline={outline}
            aria-label={difficulty}
            className={compact ? "size-4" : "size-5"}
          />
          <span className={cn("text-xs text-muted-foreground")}>{counts.get(difficulty) ?? 0}</span>
        </span>
      ))}
    </div>
  );
}
